import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { if (user) api.get("/wishlist").then(r=>setItems(r.data.items)).catch(()=>{}); }, [user]);
  if (!user) return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="wishlist-empty">
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)]">Your Wishlist</h1>
      <p className="text-sm text-neutral-600 mt-4">Sign in to save your favorite pieces.</p>
      <Link to="/auth" className="hb-btn-primary mt-6 inline-block">Sign In</Link>
    </div>
  );
  return (
    <div className="max-w-7xl mx-auto px-6 py-12" data-testid="wishlist-page">
      <h1 className="font-display text-5xl text-[color:var(--hb-navy)] mb-6">Wishlist</h1>
      {items.length === 0 ? <p className="text-sm text-neutral-500">Empty for now.</p> :
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">{items.map(p=><ProductCard key={p.product_id} product={p}/>)}</div>}
    </div>
  );
}
